import { motion } from "framer-motion";

export const SectionTitle = ({ badge, title, description, testIdPrefix, inverse = false }) => {
  return (
    <motion.div
      className="mx-auto mb-10 max-w-3xl text-center"
      data-testid={`${testIdPrefix}-section-title-wrapper`}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      {badge ? (
        <span
          className={`mb-4 inline-flex rounded-full px-4 py-2 text-sm font-semibold ${
            inverse ? "bg-white/10 text-secondary" : "bg-secondary/10 text-secondary"
          }`}
          data-testid={`${testIdPrefix}-section-badge`}
        >
          {badge}
        </span>
      ) : null}
      <h2
        className={`text-3xl font-bold tracking-tight md:text-4xl ${inverse ? "text-white" : "text-slate-900"}`}
        data-testid={`${testIdPrefix}-section-heading`}
      >
        {title}
      </h2>
      {description ? (
        <p
          className={`mt-4 text-base md:text-lg ${inverse ? "text-slate-200" : "text-slate-600"}`}
          data-testid={`${testIdPrefix}-section-description`}
        >
          {description}
        </p>
      ) : null}
    </motion.div>
  );
};
